import net from '../../utils/net'
export default {
  getjson (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
